import Cookies from 'js-cookie';
import getBrowserFingerprint from 'get-browser-fingerprint';

const COOKIE_DOMAIN = window.location.hostname === 'localhost' ? undefined : '.patsnap.com';
const COOKIE_PATH = '/';

const SOURCE_EXPIRE_DAYS = 30;
const VISITOR_EXPIRE_DAYS = 3650; // ~10 years (simulate never expire)

export const COOKIE_KEYS = {
  VISITOR_ID: 'visitor_id',
  ENTRY_CHANNEL: 'entry_channel',
  CAMPAIGN_NAME: 'campaign_name',
  PRODUCT_SOURCE: 'product_source',
};

export const useVisitorCookies = () => {
  function setCookie(key: string, value: string, days?: number) {
    Cookies.set(key, value, {
      expires: days,
      domain: COOKIE_DOMAIN,
      path: COOKIE_PATH,
    });
  }

  function getCookie(key: string) {
    return Cookies.get(key);
  }

  function getUrlParam(param: string): string | null {
    const params = new URLSearchParams(window.location.search);
    return params.get(param);
  }

  async function generateVisitorId() {
    const fingerprint = (await getBrowserFingerprint({
      hardwareOnly: false,
    })) as unknown as string;

    return fingerprint;
  }

  function checkIfHome() {
    const url = new URL(window.location.href);

    const pathname = url.pathname; // "/mse/"
    const hash = url.hash; // "#/home"

    if (pathname === '/mse/' && hash === '#/home') {
      return true;
    }

    return false;
  }

  async function initVisitorCookies() {
    // visitor id
    let visitorId = getCookie(COOKIE_KEYS.VISITOR_ID);

    if (!visitorId) {
      visitorId = await generateVisitorId();
      setCookie(COOKIE_KEYS.VISITOR_ID, visitorId, VISITOR_EXPIRE_DAYS);
    }

    // entry channel
    const entryChannel = getCookie(COOKIE_KEYS.ENTRY_CHANNEL);
    if (!entryChannel) {
      const entryChannel = checkIfHome() ? 'mse_home' : 'mse_detail_page';
      setCookie(COOKIE_KEYS.ENTRY_CHANNEL, entryChannel, SOURCE_EXPIRE_DAYS);
    }

    // campaign name
    const fromParam = getUrlParam('from');

    if (fromParam) {
      // update campaign_name if URL contains from
      setCookie(COOKIE_KEYS.CAMPAIGN_NAME, fromParam, SOURCE_EXPIRE_DAYS);
    } else if (!getCookie(COOKIE_KEYS.CAMPAIGN_NAME)) {
      // default = organic
      setCookie(COOKIE_KEYS.CAMPAIGN_NAME, 'organic', SOURCE_EXPIRE_DAYS);
    }
  }

  const initProductSourceCookies = () => {
    setCookie(COOKIE_KEYS.PRODUCT_SOURCE, 'eureka_mse', VISITOR_EXPIRE_DAYS);
  };

  return {
    initProductSourceCookies,
    initVisitorCookies,
  };
};
